// extracted by mini-css-extract-plugin
module.exports = {"container":"Filterbar__container__3F_tE","item":"Filterbar__item__3gmSQ","icon":"Filterbar__icon__2fk3N"};